var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"myIframe",staticStyle:{"width":"100%"},attrs:{"id":"bdIframe","height":"1000px","src":_vm.src,"frameborder":"0","allowtransparency":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }